import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").filter(Boolean).join(" ");
  return "Something went wrong. Please try again or call us.";
}

export function track(event, props = {}) {
  try {
    if (window.posthog && window.posthog.capture) window.posthog.capture(event, props);
  } catch (_) { /* analytics must never break the page */ }
}

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];

export function captureUtm() {
  try {
    const params = new URLSearchParams(window.location.search);
    const found = {};
    UTM_KEYS.forEach((k) => {
      const v = params.get(k);
      if (v) found[k] = v;
    });
    if (Object.keys(found).length) sessionStorage.setItem("utm", JSON.stringify(found));
  } catch (_) { /* ignore */ }
}

export function getUtm() {
  try {
    return JSON.parse(sessionStorage.getItem("utm") || "{}");
  } catch (_) {
    return {};
  }
}
